import SiteButton_ButtonShadowLeftComponent from '../components/SiteButton/viewer/skinComps/BaseButton/ButtonShadowLeft.skin';
import SiteButton_ButtonShadowLeftController from '../components/SiteButton/viewer/SiteButton.controller';


const SiteButton_ButtonShadowLeft = {
  component: SiteButton_ButtonShadowLeftComponent,
  controller: SiteButton_ButtonShadowLeftController
};


export const components = {
  ['SiteButton_ButtonShadowLeft']: SiteButton_ButtonShadowLeft
};

